import { render } from "./addressWrapper.vue?vue&type=template&id=9875de36"
import script from "./addressWrapper.vue?vue&type=script&lang=js"
export * from "./addressWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__